var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm.$route.name == 'OrgRoleList' ? _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 全系統管理 ")]) : _vm._e(), _vm.$route.name == 'OrgRoleList' ? _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationList'
      }
    }
  }, [_vm._v(" 組織管理 ")]) : _vm._e(), _vm.$route.name == 'RoleList' ? _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 組織資料中心 ")]) : _vm._e(), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("權限管理")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s("\u3010".concat(_vm.organizationName, "\u3011\u6B0A\u9650\u7BA1\u7406")) + " ")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          align-items-start align-items-xl-center\n          mb-2\n        "
  }, [_vm.checkPermission([_vm.consts.ROLE_MODIFY]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mr-2",
    attrs: {
      "variant": "primary",
      "to": _vm.getCreateLink()
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增角色 ")]) : _vm._e(), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.roles,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          attrs: {
            "variant": "inverse-dark",
            "to": _vm.getStaffLink(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-account-multiple mr-1"
        }), _vm._v("相關帳號 ")]), _c('b-button', {
          attrs: {
            "variant": "inverse-info",
            "to": _vm.getPermissionEditLink(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-account-key mr-1"
        }), _vm._v("編輯權限 ")]), _c('b-button', {
          attrs: {
            "variant": "inverse-secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.showCopyPermission(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-account-switch mr-1"
        }), _vm._v("複製權限 ")]), _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": _vm.getShowLink(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]), _vm.checkPermission([_vm.consts.ROLE_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": _vm.getEditLink(data.item)
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ROLE_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteRole(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-copy-permission",
      "title": "複製權限",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return _vm.copyPermission('remove_and_copy');
            }
          }
        }, [_vm._v(" 移除現有權限，用新權限取代 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return _vm.copyPermission('reserve_and_copy');
            }
          }
        }, [_vm._v(" 繼承現有權限，並加上新權限 ")])];
      },
      proxy: true
    }])
  }, [_c('h4', [_vm._v(_vm._s("\u8907\u88FD ".concat(_vm.selectedRole.name, " \u7684\u6B0A\u9650")))]), _c('p', [_vm._v(" " + _vm._s("\u8ACB\u9078\u53D6\u76EE\u6A19\u89D2\u8272\uFF0C\u6703\u5C07 ".concat(_vm.selectedRole.name, " \u7684\u6B0A\u9650\u5E36\u5165")) + " ")]), _c('b-form-group', [_c('b-form-select', {
    attrs: {
      "options": _vm.optionRoles
    },
    model: {
      value: _vm.targetRole,
      callback: function callback($$v) {
        _vm.targetRole = $$v;
      },
      expression: "targetRole"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }